module.exports = __webpack_public_path__ + "assets/img/18_1873_big.3f72b701.jpg";